"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultAboutOwner = void 0;
var _react = _interopRequireDefault(require("react"));
var _radios = require("../../constants/radios");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable max-len */

var patterns = {
  ownerEmail: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  ownerMobile: /^04[0-9]{8}$/
};
var DefaultAboutOwner = exports.DefaultAboutOwner = {
  heading: 'About you',
  headingReadonly: 'Confirm your details',
  accordionBehaviour: true,
  showMembershipField: true,
  showPromoCodeField: true,
  showMemberNumberField: true,
  showCustomerSource: true,
  showName: false,
  showBirthdate: true,
  showPostCode: true,
  showEmailDisclaimer: true,
  mandatoryText: null,
  showMandatoryText: false,
  showMobileField: false,
  emailDisclaimerText: function emailDisclaimerText(marketingPartner) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "emailDisclaimer secondaryText"
    }, "By providing an email address, you understand that ", marketingPartner, " may use it to send you promotions or offers relating to products and services that may be available to you. You can opt out at any time.");
  },
  mobileDisclaimerText: function mobileDisclaimerText(marketingPartner) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "mobileDisclaimer secondaryText"
    }, "By providing an email address and/or mobile number, you understand that ", marketingPartner, " may use it to send you promotions or offers relating to products and services that may be available to you. You can opt out at any time.");
  },
  tncDisclaimer: /*#__PURE__*/_react["default"].createElement("span", null, "By submitting this form and providing your mobile number, you consent to receiving a phone call and SMS from us for the purpose of discussing and providing assistance with your insurance quote and you understand that if you provide an email address, it may be used by us to send you information and offers on the products and services we provide. You can opt out of receiving calls from us when we contact you or by contacting us at ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "mailto:petinsurance@petsure.com.au"
  }, "petinsurance@petsure.com.au"), ". You acknowledge that you have had an opportunity to review and consider the relevant Product Disclosure Statement and that your personal information is collected, used and disclosed in accordance with our Privacy Policy."),
  ownerTitleInput: {
    label: 'Your title',
    validation: {
      required: 'This field is required.'
    }
  },
  ownerBirthdateInput: {
    label: 'Date of birth',
    labelTooltip: null,
    placeholder: 'dd/mm/yyyy',
    validation: {
      required: 'Please enter your date of birth.'
    }
  },
  ownerEmailInput: {
    label: 'Email',
    placeholder: 'Email address',
    validation: {
      required: 'Please enter your email address.',
      pattern: {
        value: patterns.ownerEmail,
        message: 'The entered value does not match a standard email address format.'
      }
    }
  },
  ownerNameInput: {
    label: 'Your name is...',
    placeholder: 'Enter name',
    validation: {
      required: 'Please enter your full name.'
    }
  },
  ownerFirstNameInput: {
    label: 'First name',
    placeholder: 'Enter first name',
    validation: {
      required: 'Please enter your first name.'
    }
  },
  ownerLastNameInput: {
    label: 'Last name',
    placeholder: 'Enter last name',
    validation: {
      required: 'Please enter your last name.'
    }
  },
  ownerMobileInput: {
    label: 'Mobile',
    placeholder: 'Enter mobile number',
    validation: {
      required: 'Please enter your mobile.',
      pattern: {
        value: patterns.ownerMobile,
        message: 'Mobile number is invalid'
      }
    }
  },
  ownerPostCodeInput: {
    label: 'Postcode',
    placeholder: 'Enter postcode',
    validation: {
      required: 'Please enter your postcode.'
    }
  },
  ownerMembershipRadios: {
    groupLabel: 'Do you have a member number?',
    radioInputs: _radios.SIMPLE_YES_NO
  },
  ownerMemberNumberInput: {
    name: 'ownerMemberNumberInput',
    label: 'Please enter your member number',
    placeholder: 'Enter member number'
  },
  ownerPromoCodeInput: {
    label: 'Promo code (optional)',
    placeholder: 'Enter code'
  },
  ownerAddressAutoCompleteInput: {
    label: 'Street address',
    placeholder: 'Start typing an address'
  },
  ownerEmailCommsRadios: {
    groupLabel: 'Would you like to receive all communication by email?',
    radioInputs: _radios.SIMPLE_YES_NO
  },
  ownerMarketingFeedChannel: {
    label: 'How did you hear about us?',
    placeholder: 'Other...',
    options: ['Brochure received at vet practice', 'Vet', 'Online', 'Word of mouth', 'Magazine or newspaper'],
    validation: {
      required: 'Please choose your answer.'
    }
  },
  ownerSendQuoteEmailInput: {
    label: 'Your email address is',
    placeholder: 'Email address',
    validation: {
      required: 'Please enter your email address.',
      pattern: {
        value: patterns.ownerEmail,
        message: 'The entered value does not match a standard email address format.'
      }
    }
  },
  basicOwnerFormOrder: ['ownerBirthdateInput', 'ownerPostCodeInput', 'ownerEmailInput']
};